import React, { useState, useEffect, useRef } from 'react';
import { useDropzone } from "react-dropzone";
import { GalleryStyles as styles } from "./chat.tailwind";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import upload from "../../../../../../assets/svgs/upload.svg"
// import delete_black from "../../../../../../assets/svgs/delete_black.svg"
// import save from "../../../../../../assets/svgs/save.svg";
import UploadFilePreview from './UploadFilePreview';
// import Button from '../../../../../shared/Button/Button';
import { getLiveGameMediaList, uploadMediaInLiveGame } from '../../../../../../redux/slices/liveGameSlice';
import { MAX_MEDIA_UPLOAD_LIMIT, MAX_IMAGE_SIZE_IN_MB, MAX_VIDEO_SIZE_IN_MB } from '../../../../../../lib/constants/globalConstant';
import { connect } from 'react-redux';
import { showErrorSnackbar, showSuccessSnackbar } from '../../../../../../redux/slices/snackbarSlice';
import { ACCEPTED_IMAGE_MIME_TYPES, ACCEPTED_IMAGE_EXTENSIONS, ACCEPTED_VIDEO_MIME_TYPES, ACCEPTED_VIDEO_EXTENSIONS } from './livechat.data';
import { PAGE_SIZE } from './livechat.data';

const UploadMediaDialog = ({ 
    gameId, 
    // setUploadFile, 
    uploadMedia, 
    pageNumber, 
    getMediaMessages, 
    // showSuccessMessage, 
    showErrorMessage, 
    triggerSave, // Prop to trigger handleSave
    setTriggerSave,
    setAttachmentURLs, // Setter to send result back to LiveChat
}) => {
    const containerRef = useRef(null);
    // const { uploadingMedia } = useSelector(state => state.liveGame);

    const [files, setFiles] = useState([]);
    const [allRejectedFiles, setAllRejectedFiles] = useState([]);
    const [isLeftScrollButtonDisabled, setIsLeftScrollButtonDisabled] = useState(false);
    const [isRightScrollButtonDisabled, setIsRightScrollButtonDisabled] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({
        currentFile: null,
        progress: 0,
        isUploading: false
    });
    // console.log(allRejectedFiles);

    // const onDrop = (acceptedFiles, rejectedFiles) => {   
    //     if ((files?.length + allRejectedFiles.length + acceptedFiles?.length + rejectedFiles?.length) > MAX_MEDIA_UPLOAD_LIMIT) {
    //         showErrorMessage({ title: `Can't upload more than 10 files at a moment` });
    //         return;
    //     }

    //     // clear the previous rejected Files
    //     // setAllRejectedFiles([]);

    //     // Constants for max file sizes (convert MB to bytes)
    //     const MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_IN_MB * 1024 * 1024;
    //     const MAX_VIDEO_SIZE = MAX_VIDEO_SIZE_IN_MB * 1024 * 1024;

    //     // Validate files and track which ones exceed size limits
    //     const validatedFiles = acceptedFiles.map(file => {
    //         const isImage = file?.type.startsWith('image/');
    //         const maxSize = isImage ? MAX_IMAGE_SIZE : MAX_VIDEO_SIZE;
    //         const maxSizeMB = isImage ? MAX_IMAGE_SIZE_IN_MB : MAX_VIDEO_SIZE_IN_MB;

    //         if (file.size > maxSize) {
    //             return {
    //                 file,
    //                 isRejected: true,
    //                 reason: `File size exceeds ${maxSizeMB}MB limit`
    //             };
    //         }
    //         return {
    //             file,
    //             isRejected: false
    //         };
    //     });

    //     // Add rejected files from format validation
    //     const formatRejectedFiles = rejectedFiles.map(rejection => ({
    //         file: rejection.file,
    //         isRejected: true,
    //         reason: rejection.errors[0].code
    //     }));     

    //     // Combine all files and separate valid from rejected
    //     const allFiles = [...validatedFiles, ...formatRejectedFiles];
    //     const validFiles = allFiles.filter(f => !f.isRejected).map(f => f.file);

    //     // const rejectedOnes = allFiles.filter(f => f.isRejected);
    //     const rejectedOnes = [...allRejectedFiles, ...allFiles.filter(f => f.isRejected)];

    //     // Check upload limit before setting files
    //     if (validFiles.length + files.length > MAX_MEDIA_UPLOAD_LIMIT) {
    //         const availableSlots = MAX_MEDIA_UPLOAD_LIMIT - files.length;
    //         const filesToAdd = validFiles.slice(0, availableSlots);

    //         setFiles(prevFiles => [...prevFiles, ...filesToAdd]);

    //         setAllRejectedFiles([
    //             ...rejectedOnes.map(f => ({
    //                 file: f.file,
    //                 reason: f.reason
    //             })),
    //             ...validFiles.slice(availableSlots).map(f => ({
    //                 file: f,
    //                 reason: `Can't upload more than ${MAX_MEDIA_UPLOAD_LIMIT} files`
    //             }))
    //         ]);
    //     } else {
    //         setFiles(prevFiles => ([...prevFiles, ...validFiles]));
    //         setAllRejectedFiles(
    //             rejectedOnes.map(f => ({
    //                 file: f.file,
    //                 reason: f.reason
    //             }))
    //         );
    //     }
    // };

    const onDrop = (acceptedFiles, rejectedFiles) => {
        // Early validation for total file limit
        const totalFiles = files.length + allRejectedFiles.length + acceptedFiles.length + rejectedFiles.length;
        if (totalFiles > MAX_MEDIA_UPLOAD_LIMIT) {
            showErrorMessage({ title: `Can't upload more than ${MAX_MEDIA_UPLOAD_LIMIT} files at a moment`, position: { vertical: 'bottom', horizontal: 'left' } });
            return;
        }

        // Helper function to validate file size
        const validateFileSize = (file) => {
            const isImage = file?.type.startsWith('image/');
            const maxSize = isImage ? MAX_IMAGE_SIZE_IN_MB : MAX_VIDEO_SIZE_IN_MB;

            return file.size <= maxSize * 1024 * 1024
                ? { file, isRejected: false }
                : { file, isRejected: true, reason: `File size exceeds ${maxSize}MB limit` };
        };

        // Process all files in a single pass
        const processedFiles = [
            ...acceptedFiles.map(validateFileSize),
            ...rejectedFiles.map(rejection => ({
                file: rejection.file,
                isRejected: true,
                reason: rejection.errors[0].code
            }))
        ];

        // Separate valid and rejected files
        const validFiles = processedFiles
            .filter(f => !f.isRejected)
            .map(f => f.file);

        const newRejectedFiles = [
            ...allRejectedFiles,
            ...processedFiles.filter(f => f.isRejected)
        ];

        // Handle file limit and update state
        const availableSlots = MAX_MEDIA_UPLOAD_LIMIT - files.length;
        const filesToAdd = validFiles.slice(0, availableSlots);

        if (validFiles.length + files.length > MAX_MEDIA_UPLOAD_LIMIT) {
            setAllRejectedFiles([
                ...newRejectedFiles.map(f => ({
                    file: f.file,
                    reason: f.reason
                })),
                ...validFiles.slice(availableSlots).map(f => ({
                    file: f,
                    reason: `Can't upload more than ${MAX_MEDIA_UPLOAD_LIMIT} files`
                }))
            ]);
        } else {
            setAllRejectedFiles(
                newRejectedFiles.map(f => ({
                    file: f.file,
                    reason: f.reason
                }))
            );
        }

        setFiles(prevFiles => [...prevFiles, ...filesToAdd]);
    };

    const image_types = ACCEPTED_IMAGE_MIME_TYPES.reduce((acc, mimeType, index) => {
        acc[mimeType] = [`.${ACCEPTED_IMAGE_EXTENSIONS[index]}`];
        return acc;
    }, {});

    const video_types = ACCEPTED_VIDEO_MIME_TYPES.reduce((acc, mimeType, index) => {
        acc[mimeType] = [`.${ACCEPTED_VIDEO_EXTENSIONS[index]}`];
        return acc;
    }, {});

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            ...image_types,
            ...video_types
        },
        maxSize: Math.max(
            MAX_IMAGE_SIZE_IN_MB * 1024 * 1024,
            MAX_VIDEO_SIZE_IN_MB * 1024 * 1024
        ),
    });

    // remove file from the files state
    const removeFile = (fileIndex) => {
        setFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
    };

    // remove rejected file from the rejectedFiles state
    const removeRejectedFile = (fileIndex) => {
        setAllRejectedFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
    };

    // Handle scrolling
    const handleScroll = () => {
        const container = containerRef?.current;

        if (container) {
            setIsLeftScrollButtonDisabled(container.scrollLeft > 0);
            setIsRightScrollButtonDisabled(container.scrollWidth - 10 > container.clientWidth + container.scrollLeft);
        }
    };

    // handle scroll-left
    const scrollLeft = () => {
        containerRef?.current?.scrollBy({ left: -150, behavior: 'smooth' });
    };

    // handle scroll-right
    const scrollRight = () => {
        containerRef?.current?.scrollBy({ left: 150, behavior: 'smooth' });
    };

    // handle uploading of single file 
    const uploadSingleFile = async (file) => {
        if (!gameId || !file) return;

        // const contentType = file?.type?.startsWith('image/')
        //     ? LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE
        //     : LIVE_GAME_CHAT_CONTENT_TYPE.VIDEO;

        // console.log("contentType: ", contentType);

        const data = {
            gameId,
            file: file,
        };

        setUploadProgress({
            currentFile: file.name,
            progress: 0,
            isUploading: true
        });

        try {
            const res = await uploadMedia(data, (progressEvent) => {
                if (progressEvent.loaded && progressEvent.total) {
                    // console.log("progressEvent: ", progressEvent);

                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(prev => ({
                        ...prev,
                        currentFile: file.name,
                        progress: percentCompleted
                    }));
                }
            });
            // console.log("Res: ", res);

            if (uploadMediaInLiveGame.fulfilled.match(res) || res?.meta?.requestStatus === 'fulfilled') {
                // console.log('in if');
                
                // Add file to uploaded files list
                setUploadedFiles(prev => [...prev, file.name]);
                // console.log('in btw');
                
                // uploadedMediaFiles.push({
                //     url: res.payload.url,
                //     contentType: res.payload.contentType
                // });
                // console.log('retu');
                
                return { url: res.payload.url, contentType: res.payload.contentType, mediaId: res.payload.mediaId };
            } else {
                return null;
            }

        } catch (error) {
            console.error(`Error uploading ${file.name}:`, error);
            setTriggerSave(false);
            return null;
        }
    };

    // handle uploading of all the accepted media files
    const handleSave = async () => {
        if ((files?.length === 0 && allRejectedFiles?.length > 0)) {
            showErrorMessage({ title: `Please select a valid File and remove the discarded ones.` });
            setTriggerSave(false);
            return;
        }

        // if (!files.length) {
        //     showErrorMessage({ title: "No files to upload. Please Accept a File to continue" });
        //     return;
        // }

        if (allRejectedFiles?.length) {
            showErrorMessage({ title: `Some of the files can't be uploaded. Please discard them to continue.` });
            setTriggerSave(false);
            return;
        }

        if (files?.length === 0) return []; // No files to upload

        try {
            let successCount = 0;
            let uploadedMediaFiles = [];

            // Upload files sequentially
            for (let i = 0; i < files.length; i++) {
                const uploadedFile = await uploadSingleFile(files[i]);
                // console.log(uploadedFile);
                // console.log(uploadedMediaFiles);
                
                if (uploadedFile) {
                    successCount++;
                    uploadedMediaFiles.push(uploadedFile);
                }
            }

            // Reset upload progress
            setUploadProgress({
                currentFile: null,
                progress: 0,
                isUploading: false
            });
            setUploadedFiles([]); // Reset uploaded files

            if (successCount > 0) {
                // // Determine content type based on upload
                // const contentType = successCount > 1 
                //     ? LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA 
                //     : (uploadedMediaFiles[0]?.contentType || LIVE_GAME_CHAT_CONTENT_TYPE.MEDIA);

                // // Call handleSendMessage with uploaded media details
                // handleSendMessage({
                //     contentType: contentType,
                //     attachmentURLs: uploadedMediaFiles
                // });

                // Show completion message or handle completion logic
                // showSuccessMessage({ title: `Successfully uploaded ${successCount} of ${files.length} files`, position: { vertical: "bottom", horizontal: "left" } });
            }
            // console.log(`Successfully uploaded ${successCount} of ${files.length} files`);
            const data = {
                gameId,
                page: String(pageNumber),
                limit: String((pageNumber * PAGE_SIZE))
            }
            await getMediaMessages(data)
            // Clear the files state and close the dialog
            setFiles([]);
            // setUploadFile(false);
            // console.log('uploadedMediaFiles: ', uploadedMediaFiles);
            
            return uploadedMediaFiles
        } catch (error) {
            console.error("Error in upload process:", error);
            setUploadProgress(prev => ({
                ...prev,
                isUploading: false
            }));
        }
    };

    // Trigger handleSave when triggerSave changes to true
    useEffect(() => {
        if (triggerSave) {
        const executeSave = async () => {
            const result = await handleSave();
            setAttachmentURLs(result); // Send result back to LiveChat
        };
        executeSave();
        }
    }, [triggerSave]);
    // console.log(triggerSave);
    

    useEffect(() => {
        const container = containerRef.current;
        /**
         * Checks the scroll position of the container and updates the visibility of scroll icons.
         * If the content is scrollable, the right scroll icon is shown.
         * If the content has been scrolled from the left, the left scroll icon is shown.
         */
        const checkScrollIcons = () => {
            if (container) {
                const isScrollable = (container.scrollWidth) > (container.clientWidth + container?.scrollLeft);
                setIsRightScrollButtonDisabled(isScrollable);
                setIsLeftScrollButtonDisabled(container.scrollLeft > 0);
            }
        };

        checkScrollIcons();
        container?.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', checkScrollIcons);

        return () => {
            container?.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', checkScrollIcons);
        };
    }, [files]);

    useEffect(() => {
        // if (files?.length > MAX_MEDIA_UPLOAD_LIMIT) {
        //     console.error("max Limit Reached!!");
        //     setUploadLimitReached(true);
        //     setFiles([]);
        // }

        return () => {
            files?.forEach((file) => URL.revokeObjectURL(file.preview));
        };
    }, [files]);

    return (
        <div className={`${styles.dragAndDropOuterContainer} ${files?.length > 0 ? "justify-between" : "justify-start"}`}>
            {/* buttons */}
            {/* <div className="w-full flex justify-between">
                <Button
                    className={styles.galleryButton}    
                    variant="secondary"
                    disabled={uploadProgress?.isUploading}
                    onClick={() => setUploadFile(false)}
                >
                    <img src={delete_black} className={styles.icon} />
                    <span>Discard</span>
                </Button>

                <Button
                    className={styles.galleryButton} 
                    variant="secondary"
                    disabled={uploadProgress?.isUploading || files?.length === 0}
                    onClick={handleSave}
                >
                    <img src={save} className={styles.icon} />
                    <span>{uploadingMedia ? "Saving..." : "Save"}</span>
                </Button>
            </div> */}

            {/* buttons */}
            {files?.length > 0 && <div className={styles.uploadContainerHeader}>
                <p className={styles.uploadedFiles}>Uploaded Files</p>

                <div className={styles.uploadedbuttons}>
                    <button className={styles.goldButton} onClick={scrollLeft} disabled={!isLeftScrollButtonDisabled}>
                        <KeyboardArrowLeftIcon fontSize='25px' />
                    </button>
                    <button className={styles.goldButton} onClick={scrollRight} disabled={!isRightScrollButtonDisabled}>
                        <KeyboardArrowRightIcon fontSize='25px' />
                    </button>
                </div>
            </div>}

            <div className='w-full flex gap-2'>
                {/* dropzone */}
                <div
                    {...getRootProps()}
                    className={`${styles.dragAndDropContainer} ${files?.length > 0 ? styles.dragAndDropContainerInner : 'w-full h-full py-[30px]'}`}
                >
                    <input {...getInputProps()} />
                    <div className={`${styles.icon} ${styles.uploadicon}`}>
                        <img src={upload} />
                    </div>

                    <div className={styles.dragAndDropText}>
                        <p className={`${files?.length > 0 && 'text-[10px] screen-500:text-[12px] text-center'}`}><span className='text-primaryGold'>Click to Upload</span> or drag and drop</p>
                        {!files?.length > 0 && <div className={styles.dragAndDropSubText}>
                            <p>(Max.File size Image: {MAX_IMAGE_SIZE_IN_MB} MB, Video: {MAX_VIDEO_SIZE_IN_MB} MB)</p>
                            <p>(Max.File Upload Limit: {MAX_IMAGE_SIZE_IN_MB})</p>
                        </div>}
                        {/* <p>(Max.File size Image: {MAX_IMAGE_SIZE_IN_MB} MB)</p> */}
                        {/* <p>(Max.File size Video: {MAX_VIDEO_SIZE_IN_MB} MB)</p>
                    <p>(Max.File Upload Limit: {MAX_IMAGE_SIZE_IN_MB})</p> */}
                    </div>
                </div>

                {/* Files preview */}
                {(files?.length > 0 || allRejectedFiles?.length > 0) && (
                // <div className={styles.uploadOuterContainerNew} >
                    <div className={styles.uploadedFilesPreviewContainer} ref={containerRef} style={{ scrollbarWidth: 'none' }}>
                        {/* Accepted Files */}
                        {
                            files?.length > 0 && (
                                files.map((file, index) => {
                                    return (
                                        <UploadFilePreview
                                            key={index}
                                            file={file}
                                            index={index}
                                            uploadProgress={uploadProgress}
                                            removeFile={removeFile}
                                            uploadedFiles={uploadedFiles}
                                            removeRejectedFile={removeRejectedFile}
                                        />
                                    );
                                })
                            )
                        }

                    {/* Rejected Files */}
                    {
                        allRejectedFiles?.length > 0 && (
                            allRejectedFiles.map((file, index) => {
                                return (
                                    <UploadFilePreview
                                        key={index}
                                        file={file?.file}
                                        uploadProgress={uploadProgress}
                                        index={index}
                                        removeFile={removeFile}
                                        uploadedFiles={uploadedFiles}
                                        isRejected={true}
                                        reason={file?.reason}
                                        removeRejectedFile={removeRejectedFile}
                                    />
                                );
                            })
                        )
                    }
                </div>
                // </div>
            )}
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    uploadMedia: (data, onProgress) => dispatch(uploadMediaInLiveGame({ data, onProgress })),
    getMediaMessages: (data) => dispatch(getLiveGameMediaList(data)),
    showSuccessMessage: (data) => dispatch(showSuccessSnackbar(data)),
    showErrorMessage: (data) => dispatch(showErrorSnackbar(data))
})

export default connect(null, mapDispatchToProps)(UploadMediaDialog);